export default "__VITE_ASSET__81a50096__"